import React from "react";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
  _450px,
} from "../../utils/mediaBreakpoints";

const CommitmentToSecurity = ({ data }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const head = "Our Commitment to Security";
  const para =
    "At ASK FIDES, trust is non-negotiable. Built for the legal profession,\nour platform is designed to meet the strictest standards of data\nprotection, confidentiality, and verifiable intelligence.";
  return (
    <>
      <div className="row ">
        <div className="col-12 p-5" style={{ background: "#E9ECF4" }}>
          <div className="d-flex align-items-center justify-content-center flex-column gap-2">
            <p
              className="fw900 "
              style={{
                color: "#1F46BE",

                fontSize: _450
                  ? "20px"
                  : _576
                  ? "30px"
                  : _768
                  ? "30px"
                  : _992
                  ? "40px"
                  : _1200
                  ? "40px"
                  : _1400
                  ? "45px"
                  : _1600
                  ? "50px"
                  : _1700
                  ? "60px"
                  : _1800
                  ? "70px"
                  : "70px",
              }}
            >
              {data?.heading}
            </p>
            <p
              className="text-center fw600 lh-sm"
              style={{
                color: "#1F46BE",
                fontSize: _450
                  ? "13px"
                  : _576
                  ? "13px"
                  : _768
                  ? "13px"
                  : _992
                  ? "15px"
                  : _1200
                  ? "15px"
                  : _1400
                  ? "17px"
                  : _1600
                  ? "19px"
                  : _1700
                  ? "22px"
                  : _1800
                  ? "26px"
                  : "26px",
              }}
              dangerouslySetInnerHTML={{
                __html: _576?data?.description:data?.description?.split("\n")?.join("<br/>"),
              }}
            ></p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommitmentToSecurity;
